import { get } from "lodash";
import api from "@/services/api";

// Servico centralizado de candidatura/perguntas personalizadas.
// Reune a logica que antes vivia duplicada em DetailVacancy.vue, sempre pela
// instancia `api` (VUE_APP_API_BASE_URL; o interceptor injeta o bearer e trata 401).

// Dados publicos da vaga (empresa, logo e a vaga em si) para montar a modal.
// Shape do endpoint /api/v2/companies/{label}/{vacancyId} (CompaniesController@show):
//   data: { id (company_id), name (company), logo_url, base_hexcolor,
//           vacancy: { id, name (titulo), slug, uuid, manager_id } }
export async function fetchPublicVacancy(companyLabel, vacancyId) {
  const response = await api.get(
    `/api/v2/companies/${companyLabel}/${vacancyId}`
  );

  const { id, name, logo_url, base_hexcolor, vacancy } = response.data.data;

  return {
    company: { id, name, logo_url, base_hexcolor },
    vacancy,
  };
}

// A vaga possui perguntas personalizadas? Retorna o step_id quando sim.
export async function checkVacancyForms(vacancyId) {
  try {
    const response = await api.get(
      `/api/v1/questions/steps/vacancies/${vacancyId}/exists`
    );

    const stepId = get(response, "data.data.step_id", null);

    return { hasForms: !!stepId, stepId };
  } catch (_) {
    return { hasForms: false, stepId: null };
  }
}

// O candidato ja respondeu as perguntas personalizadas desse step?
// Mesma API principal dos demais endpoints (VUE_APP_API_BASE_URL); o bearer
// e injetado pelo interceptor de api.js.
export async function checkFormsAnswered(vacancyId, stepId) {
  if (!stepId) return true;

  try {
    const response = await api.get(
      `/api/v1/questions/steps/vacancies/${vacancyId}/${stepId}`
    );

    const forms = get(response, "data.data.forms", []);

    // Se ha forms retornados, ainda existem perguntas a responder.
    return !(forms.length > 0);
  } catch (error) {
    // 304/404/409 (sem perguntas pendentes) ou erro: considerar respondido.
    return true;
  }
}

// Cria a candidatura. Retorna { created } da API.
// channel/utm_campaign/utm_medium alimentam application_sources no backend
// (mesmos campos que o fluxo deslogado de login/register grava).
export async function createApplication({
  companyLabel,
  vacancyId,
  companyId,
  managerId,
  channel,
  utmCampaign,
  utmMedium,
}) {
  const body = {
    vacancy_id: vacancyId,
    company_id: companyId,
    manager_id: managerId,
  };

  if (channel) body.channel = channel;
  if (utmCampaign) body.utm_campaign = utmCampaign;
  if (utmMedium) body.utm_medium = utmMedium;

  const response = await api.post(
    `/api/v1/talent/${companyLabel}/user/applications`,
    body
  );

  return {
    status: response.status,
    created: get(response, "data.created", false),
  };
}

// Candidatura ja existente do talento para a vaga (autenticada).
// O endpoint retorna { ap: <id|null> }: `ap` e o id da candidatura ou null.
// Serve tambem para validar o token: um 401 dispara o interceptor de api.js.
export async function fetchExistingApplication(vacancyId) {
  try {
    const response = await api.get(
      `/api/v2/talents/application?vacancy_id=${vacancyId}`
    );

    const applicationId = get(response, "data.ap", null);

    return { exists: !!applicationId, applicationId };
  } catch (error) {
    // Sem candidatura / erro: tratar como nao candidatado.
    return { exists: false, applicationId: null };
  }
}
